import React, { useCallback, useState } from 'react';
import { useField, useFormikContext } from 'formik';
import { SimpleModalTW } from '../../../../../../tailwindComponents/modals/SimpleModalTW';
import { SetCloserForm } from '../../../../overview/Summary/summaryTab/emdAmount/SetCloserForm';
import { SelectValue } from '../../../../../../tailwindComponents/selectTW/interfaces';
import { IDetailsFormData } from './types/IDetailsFormData';

export const QuickCloserSet: React.FC = () => {
  const [, fieldMetaProps] = useField<SelectValue>({ name: 'ownerType' });
  const { validateForm } = useFormikContext<IDetailsFormData>();
  const isError = fieldMetaProps.error;
  const [open, setOpen] = useState(false);

  const onSuccess = useCallback(async () => {
    setOpen(false);
    await validateForm();
  }, [validateForm]);

  if (!isError) {
    return null;
  }

  return (
    <>
      <SimpleModalTW open={open} setOpen={setOpen} titleNode={<div className={'text-lg font-bold'}>Set Closer</div>}>
        <div className={'w-full'}>
          <SetCloserForm onSuccess={onSuccess} />
        </div>
      </SimpleModalTW>
      <button className={'h-fit w-fit text-blue-600 underline'} type={'button'} onClick={() => setOpen(true)}>
        Quickly set a closer
      </button>
    </>
  );
};
